import { useCallback, memo } from 'react';
import BookingGridBase from '../common/BookingGridBase';
import BookingCardRallyev2 from './BookingCardRallyev2';
import RegiondoBookingCardBase from '../common/RegiondoBookingCardBase';

function GridRallye({
  bookings,
  rowCount,
  date,
  capacity,
  slotCapacity,
  updateBooking,
  handleOpenModal,
  onBookingShift,
  entertainment,
  onDragStart,
  onDragActivated,
  onDragEnd,
  availableShiftTimes,
  draggedBookingDuration,
  isShiftable,
  isLoadingShiftTimes,
}) {
  const calcAttendance = useCallback(
    bookingsList => {
      const cap = Number(slotCapacity) || 0;
      const items = Array.isArray(bookingsList) ? bookingsList : [];

      const times = Array.from({ length: (24 - 9) * 2 + 1 }, (_, index) => {
        const hour = 9 + Math.floor(index / 2);
        const minute = index % 2 === 0 ? '00' : '30';
        return {
          isFull: index % 2 === 0,
          time: `${hour}:${minute}`,
          qualifiedTime: new Date(date.get('year'), date.get('month'), date.get('date'), hour, minute),
          i: index,
          s0: 0,
          frees0: cap,
        };
      });

      for (const bk of items) {
        const bookingType = bk?.bookingType;
        const startKey = bookingType === 'RegiondoBooking' ? 'eventStart' : 'startTime';
        const endKey = bookingType === 'RegiondoBooking' ? 'eventEnd' : 'endTime';

        const compStart = new Date(bk?.[startKey]);
        const compEnd = new Date(bk?.[endKey]);
        if (Number.isNaN(compStart.getTime()) || Number.isNaN(compEnd.getTime())) continue;

        const countRaw =
          bk?.participantCount ?? bk?.laneCount ?? bk?.groupParticipantCount ?? 0;
        const count = Number(countRaw) || 0;
        const isBlocked = bk?.status === 'blocked';

        for (const t of times) {
          if (compStart <= t.qualifiedTime && compEnd > t.qualifiedTime) {
            const used = isBlocked ? cap : count;
            if (!isBlocked) {
              t.s0 += used;
            }
            t.frees0 -= used;
          }
        }
      }

      return times;
    },
    [date, slotCapacity]
  );

  return (
    <BookingGridBase
      bookings={bookings}
      rowCount={rowCount}
      date={date}
      slotCapacity={slotCapacity}
      calcAttendance={calcAttendance}
      capacityData={null}
      availableShiftTimes={availableShiftTimes}
      draggedBookingDuration={draggedBookingDuration}
      isLoadingShiftTimes={isLoadingShiftTimes}
      renderBookingCard={(booking, idx, rowHeight) =>
        booking?.bookingType === 'RegiondoBooking' ? (
          <RegiondoBookingCardBase key={booking._id} booking={booking} renderAvailableSlots={false} />
        ) : (
          <BookingCardRallyev2
            key={booking._id}
            booking={booking}
            handleOpenModal={handleOpenModal}
            renderAvailableSlots={false}
            rowHeight={rowHeight}
            onBookingShift={onBookingShift}
            entertainment={entertainment}
            onDragStart={onDragStart}
            onDragActivated={onDragActivated}
            onDragEnd={onDragEnd}
            availableShiftTimes={availableShiftTimes}
            isShiftable={isShiftable}
          />
        )
      }
      renderAvailableSlots={false}
    />
  );
}

export default memo(GridRallye);

